"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsEditor = void 0;
const classnames_1 = __importDefault(require("classnames"));
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Field_1 = require("../../Form/Field");
const Icon_1 = require("../../Icon");
const PermissionsGroup_1 = require("../PermissionsGroup/PermissionsGroup");
const messages_1 = require("./messages");
require("./permissions-editor.scss");
const PermissionsEditor = (props) => {
    const { className, onChange, permissions, disabled, onRestore, } = props;
    const classNames = (0, classnames_1.default)('permissions-editor', className !== null && className !== void 0 ? className : '');
    const [searchString, setSearchString] = (0, react_1.useState)('');
    const onChangeSearchString = (0, react_1.useCallback)((e) => {
        setSearchString(e.target.value);
    }, []);
    const filteredItems = (0, react_1.useMemo)(() => permissions.filter(p => p.title.toLowerCase().includes(searchString.toLowerCase())), [searchString, permissions]);
    const tree = (0, react_1.useMemo)(() => (0, groupBy_1.default)(filteredItems, (item) => item.groupName), [filteredItems]);
    const intl = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: 'permissions-editor__input' },
            react_1.default.createElement(Field_1.FormField, { placeholder: intl.formatMessage(messages_1.messages.searchPlaceholder), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/PermissionsPage:allPermissions', defaultMessage: 'All Permissions' }), modificators: ['search-field'], addonIcon: 'search', value: searchString, onChange: onChangeSearchString })),
        react_1.default.createElement("div", { className: 'permissions-editor__list' }, Object.keys(tree).map(groupName => (react_1.default.createElement(PermissionsGroup_1.PermissionsGroup, { key: groupName !== null && groupName !== void 0 ? groupName : 0, title: groupName, items: tree[groupName], onChange: onChange, disabled: disabled })))),
        onRestore && (react_1.default.createElement("button", { className: 'permissions-editor__restore', onClick: onRestore, hidden: disabled },
            react_1.default.createElement(Icon_1.Icon, { name: 'restore' }),
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/PermissionsPage:restore', defaultMessage: 'Restore defaults' })))));
};
exports.PermissionsEditor = PermissionsEditor;
//# sourceMappingURL=PermissionsEditor.js.map